import React from "react";
import "./Home_Styles/Home_Description.css";


const HomeDescription = () => {
  return (
    <div>
      <div className="descriptionWrapper">
        <div className="descLinks">
          <h3>Top-Selling Healthcare Products:</h3>
          <span>
            <a href="https://pharmeasy.in/health-care/products/accu-chek-active-100-strips-172158">
              Accu-Chek Active - 100 Strips
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/health-care/products/supradyn-multi-vitamin-tablet-15-s-293">
              Supradyn Multivitamin Tablets
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/health-care/products/dr-morepen-bg-03-50-strips-172151">
              DR Morepen BG 03 - 50 Strips
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/health-care/products/dettol-antiseptic-liquid-550-ml-214952">
              Dettol Antiseptic Liquid
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/health-care/products/ensure-diabetes-care-vanilla-sugar-free-jar-400gm-192393">
              Ensure Diabetes Care Vanilla Sugar Free Jar
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/health-care/products/dettol-instant-hand-sanitizer-original-200-ml-171058">
              Dettol Instant Hand Sanitizer
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/health-care/products/everherb-shilajit-strength-vigour-power-anti-ageing-60-veg-capsules-234976">
              Everherb Shilajit
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/health-care/products/softovac-sf-powder-250gm-214770">
              Softovac SF Powder
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/health-care/products/pediasure-premium-chocolate-refill-1kg-190269">
              Pediasure Premium Chocolate Refill
            </a>
          </span>
        </div>
        <div className="descLinks">
          <h3>Top-Selling Medicines:</h3>
          <span>
            <a href="https://pharmeasy.in/online-medicine-order/dolovera-gel-30gm-176128">
              Dolovera Gel
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/online-medicine-order/neurobion-forte-tablet-50-201749">
              Neurobion Forte
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/online-medicine-order/chymoral-forte-strip-of-20-tablets-40467">
              Chymoral Forte
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/online-medicine-order/crocin-advance-500mg-strip-of-15-tablets-42306">
              Crocin Advance
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/online-medicine-order/soframycin-1-skin-cream-100gm-172663">
              Soframycin
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/online-medicine-order/dexorange-syp-200ml-10899">
              Dexorange
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/online-medicine-order/becadexamin-cap-30-s-36928">
              Becadexamin
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/online-medicine-order/folvite-5mg-strip-of-45-tablets-29621">
              Folvite
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/online-medicine-order/livogen-captab-15-s-8730">
              Livogen
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/online-medicine-order/becosules-z-strip-of-15-capsules-36993">
              Becosules
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/online-medicine-order/fourderm-cream-20gm-6864">
              Fourderm
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/online-medicine-order/nurokind-plus-rf-cap-10-s-175901">
              Nurokind Plus
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/online-medicine-order/burnol-cream-10gm-38470">
              Burnol
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/online-medicine-order/crocin-650mg-fast-release-tablet-15-s-171919">
              Crocin 650
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/online-medicine-order/mintop-forte-5-solution-60ml-8206">
              Mintop 5
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/online-medicine-order/thrombophob-gel-20gm-30466">
              Thrombophob
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/online-medicine-order/evion-600mg-strip-of-10-capsules-46327">
              Evion 600
            </a>
          </span>
        </div>
        <div className="descLinks">
          <h3>COVID-19 Preventatives:</h3>
          <span>
            <a href="https://pharmeasy.in/health-wellness/collections/n95-masks-12">
              N95 Masks
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/health-wellness/collections/hand-sanitizers-22">
              Hand Sanitizers
            </a>
          </span>
          <span>
            <a href="https://pharmeasy.in/health-care/daily-essentials-197/covid-19-preventatives-198">
              Hand Gloves, Disinfectants, Thermometers &amp; more!
            </a>
          </span>
        </div>
        <div className="TextDiv" >
        <h1 className="descH1">Your One-Stop Online Pharmacy - PharmEasy</h1>
        <h2 className="descH2">We've got India Covered!</h2>
        <p className="descP">
          We now deliver in 1000+ cities and towns across 22000+ pin codes. We
          thereby cover every nook and corner of the country! The major cities
          in which we deliver include Mumbai, Kolkata, Delhi, Bengaluru,
          Ahmedabad, Hyderabad, Chennai, Thane, Howrah, Pune, Gurgaon, Navi
          Mumbai, Jaipur, Noida, Lucknow, Ghaziabad &amp; Vadodara.
        </p>
        <h2 className="descH2">
          Say Goodbye to All Your Healthcare Worries With PharmEasy!
        </h2>
        <p className="descP">
          PharmEasy is here to help you take it easy! We are amongst one of
          India's top online pharmacy and medical care platforms. It enables you
          to order pharmaceutical and{" "}
          <a href="##" >
            healthcare products online
          </a>{" "}
          by connecting you to registered retail pharmacies and get them
          delivered to your home. We are an online medical store, making your
          purchase easy, simple, and affordable!
        </p>
        <h2 className="descH2">
          How Are We Making Lives Simpler With Our Online Medical Store?
        </h2>
        <p className="descP">
          Our doorstep delivery service is available in PAN-India across top
          cities like Bangalore, Delhi, Mumbai, Kolkata, Hyderabad, Gurgaon,
          Noida, Pune, etc. Our online medical store also allows you to choose
          from 1 lakh+ products incl. OTC products and medical equipment.
          PharmEasy is a one-stop online medical platform where you can also
          book{" "}
          <a  href="##">
            {" "}
            diagnostic tests{" "}
          </a>{" "}
          including blood tests, full-body checkups, and other preventive health
          check-ups at an affordable cost, right from the comfort of your home.
          We have partnered with trusted &amp; certified labs that arrange for a
          sample pick-up from the convenience of your home. They also provide
          you with timely reports.
        </p>
        <h2 className="descH2">Why Are We The Most Preferred Online Pharmacy?</h2>
        <p className="descP">
          Lucrative offers on our platform allow you to make payment online and
          via various payment wallets at a discounted price. Alternatively, you
          can also choose to pay cash on delivery as we deliver the products at
          your doorstep. We cater to all your pharmaceutical needs and also make
          <a  href="##">
            {" "}
            ordering medicines online
          </a>{" "}
          a hassle-free experience for you. We connect you only with registered
          retail pharmacies &amp; certified diagnostic labs. We ensure that
          healthcare is affordable to all and make the process of ordering
          online simple.
        </p>
        <h2 className="descH2">
          Sit Back &amp; Relax While You Get Your Essentials Delivered Every
          Month!
        </h2>
        <p className="descP">
          It’s tough to remember to refill every month, especially in the case
          of chronic diseases. PharmEasy’s subscription service not only ensures
          that you are reminded of your refills but also makes sure that you are
          never out on your medical essentials. You will get a reminder every
          month and your order will be delivered at your convenience!
        </p>
        <h2 className="descH2">Access medical and health information:</h2>
        <p className="descP">
          PharmEasy delivers reliable and accurate medical information that has
          been carefully written, vetted and validated by our health experts.
          Our specialists curate high-quality and most reliable literature about
          medicines, illnesses, lab tests, Ayurvedic and over the counter health
          products.
        </p>
        <h2 className="descH2">
          We Believe in ‘Simplifying Healthcare, Impacting Lives!’
        </h2>
        </div>
      </div>
    </div>
  );
};

export default HomeDescription;
